import React from 'react';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import ContinueButtonBar from '../components/ContinueButtonBar';
import { useWheelLocale } from '../hooks/useWheelLocale';
import FamilyInfoChatComposer from './FamilyInfoChatComposer';
import FamilyInfoChatThread from './FamilyInfoChatThread';
import { useFamilyInfoFlow } from './useFamilyInfoFlow';
import '../GeneralProfile/GeneralProfileChatFlow.css';

export interface FamilyInfoChatFlowProps {
  onBack: () => void;
  onComplete: () => void;
  currentEmail?: string | null;
  invitationId?: string | null;
}

const FamilyInfoChatFlow: React.FC<FamilyInfoChatFlowProps> = ({
  onBack,
  onComplete,
  currentEmail,
  invitationId,
}) => {
  const { t } = useLanguage();
  const wheelLocale = useWheelLocale();
  const flow = useFamilyInfoFlow({ currentEmail, invitationId, onComplete, t, wheelLocale });

  return (
    <div className="gen-profile-chat">
      <div className="gen-profile-chat__card">
        <header className="gen-profile-chat__top">
          <button type="button" className="gen-profile-chat__cancel-pill" onClick={onBack}>
            <span className="gen-profile-chat__cancel-x" aria-hidden>
              ×
            </span>
            {t('submitDocuments.chat.cancelProcedure')}
          </button>
        </header>

        <div className="gen-profile-chat__thread-wrap">
          <FamilyInfoChatThread flow={flow} />
        </div>

        <footer className="gen-profile-chat__composer">
          {flow.saveError && (
            <p style={{ color: '#b83d4c', fontSize: 12, padding: '8px 16px 0', margin: 0 }}>{flow.saveError}</p>
          )}
          {flow.step === 'finalConfirm' && flow.expandedMemberIndex === null ? (
            <ContinueButtonBar onContinue={() => void flow.handleFinalComplete()} />
          ) : flow.step === 'finalConfirm' && flow.expandedMemberIndex !== null ? (
            <ContinueButtonBar
              onContinue={flow.collapseMemberEditReview}
              label={t('submitDocuments.familyInfo.backToReview')}
            />
          ) : (
            <FamilyInfoChatComposer flow={flow} />
          )}
        </footer>
      </div>
    </div>
  );
};

export default FamilyInfoChatFlow;
